import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const FeriasVantagemService = {

    async listarFeriasVantagem() 
    {
        const response = await BaseService.fetchResponseFromAPIGet(`ferias/vantagem`);
        if (response.error) {
          SnackBarModule("Houve um erro ao listar as unidades", "error");
        }
        return response.content;
    },

    async aprovarFeriasVantagem(formData) 
    {
        const response = await BaseService.fetchResponseFromAPIPost(`ferias/aprovar/vantagem`, formData);
        if (response.error) {
          SnackBarModule("Selecione pelo menos um militar", "error");
          return false;
        }
        SnackBarModule("Férias para vantagem aprovadas com sucesso", "success");
        return true;
    },
    
}

